import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface TimerState {
  name: string
  register: {
    verificationCodeSeconds: string | number
  }
  tokenTimer: {
    timestamp: number
  }
}

const initialState: TimerState = {
  name: 'timer',
  register: {
    verificationCodeSeconds: 'verificationCodeSeconds',
  },
  tokenTimer: {
    timestamp: 0,
  },
}

const slice = createSlice({
  name: 'timer',
  initialState,
  reducers: {
    updateRegisterVerificationCodeSeconds: (state, action: PayloadAction<string | number>) => {
      state.register.verificationCodeSeconds = action.payload
    },
    updateTokenTimer: (state, action: PayloadAction<number>) => {
      state.tokenTimer.timestamp = action.payload
    },
  },
})

export const { actions } = slice
export default slice.reducer
